<template>
  表格
</template>

<script>
import componentMixin from './componentMixin';

export default {
  name: "specialE",
  mixins: [componentMixin],
  computed: {
    imgSrc() {
      const image = this.$dt(this.eleConfig, 'image') || this.eleConfig.image;
      return image ? this.$Dolphin.path.publicPath + image.filePath : '';
    },
  }
};
</script>

<style scoped lang="scss">
.img-and-content-container {
  width: 100%;
  padding: 96px 0;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .img-and-content-inner {
    width: 1280px;
    margin: 0 auto;
    display: flex;

    &.img-right {
      flex-direction: row-reverse;
    }

    .img-box {
      flex: 1;

      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }

    .text-box {
      flex: 1;

      .title {
        font-size: 32px;
        font-weight: 600;
        margin-bottom: 16px;
        line-height: 45px;
        color: #003C82;
      }

      .content {
        font-size: 18px;
        white-space: pre-wrap;
        line-height: 25px;
        color: #333333;
      }
    }

    .data-list-box {
      display: flex;
      flex-direction: column;
      gap: 24px;

      .data-row {
        display: flex;
      }

      .as-circle {
        height: 8px;
        width: 8px;
        border-radius: 50%;
        flex-shrink: 0;
        margin-top: 8px;
        margin-right: 14px;
      }

      .data-text {
        flex: 1;
        font-size: 18px;
        line-height: 25px;
      }
    }
  }
}
</style>
